import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { loginError, userLogin } from "../store/actions/authActions";
import './LoginPage.scss';

const selector = state => {
    return {
        disableButtons: state.disableButtons,
        modalState: state.modalState,
        authError: state.authError,
        t: state.language.translator
    };
};

const LoginPage = () => {

    const { t, disableButtons, modalState, authError } = useSelector(selector);
    const dispatch = useDispatch();
    const history = useHistory();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const loginOnEnter = e => {
        if (e.keyCode === 13) {
            dispatch(userLogin(username, password, history))
        }
    };

    return (
        <div className='loginPage'>

            <div
                className='loginWindow'
                onKeyDown={loginOnEnter}
            >
                <div className='loginWindowTitle'>
                    <span className='material-icons loginFormIcon'>
                        account_box
                    </span>
                </div>

                <div id='loginErrorMessage' className='loginErrorMessage'>
                    {authError && (!modalState.flag && modalState.modal !== 'signUp') &&
                        t.gettext('Authorization failed. Please try again.')
                    }
                </div>

                <form className='loginForm'>
                    <div className='loginFormItem'>
                        <label className='loginFormLabel'>
                            {t.gettext('Username')}
                        </label>
                        <input
                            className='loginFormInput'
                            value={username}
                            onInput={e => {
                                setUsername(e.target.value);
                                dispatch(loginError(''))
                            }}
                            type='text'
                            autoComplete='username'
                        />
                    </div>
                    <div className='loginFormItem'>
                        <label className='loginFormLabel'>
                            {t.gettext('Password')}
                        </label>
                        <input
                            className='loginFormInput'
                            value={password}
                            onInput={e => {
                                setPassword(e.target.value);
                                dispatch(loginError(''))
                            }}
                            type='password'
                            autoComplete='current-password'
                        />
                    </div>

                    <div className='loginButtonHolder'>
                        <button
                            className='loginButton'
                            onClick={() => dispatch(userLogin(username, password, history))}
                            disabled={
                                disableButtons ||
                                typeof username !== 'string' || username.trim().length === 0 ||
                                typeof password !== 'string' || password.trim().length === 0
                            }
                        >
                            {t.gettext('Log in').toUpperCase()}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;

